module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0024.jpg?v=12c702fe";